import React from "react";

const MergerCSV = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://suppressionagent.livauto.com/MailSorter/files.php"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="Merger CSV"
      ></iframe>
    </div>
  );
};

export default MergerCSV;
